define([
    "../../hereMapsModule",
    "angular",
    "text!./monitorableHereMap.html",
], function (hereMapsModule, angular, monitorableHereMapView) {
    "use strict";

    return hereMapsModule.directive("monitorableHereMaps", [
        "hereMapsService",
        "hereMapsLoadingService",
        "mapsDirectionsService",
        "hereMapsRoutesFactory",
        "hereMapsMarkersFactory",
        function (hereMapsService,
                  hereMapsLoadingService,
                  mapsDirectionsService,
                  hereMapsRoutesFactory,
                  hereMapsMarkersFactory) {
            return {
                restrict: "E",
                template: monitorableHereMapView,
                scope: {
                    routes: "=",
                    markersPoints: "=?",
                    clusterMarkersPoints: "=?",
                    staticRoutes: "=?",
                    toggleStaticRoutes: "=?",
                    icons: "=?",
                    configurations: "<?",
                    onRegisterApi: "=",
                    onRefreshCallback: "=?"
                },
                controller: ["$scope", "$timeout", "$q", "$compile", "$templateCache", "$interval", "monitoringService", "messagesModal", "remoteExceptionHandler", "remoteMessageModal", "routeStopModalService",
                    function ($scope, $timeout, $q, $compile, $templateCache, $interval, monitoringService, messagesModal, remoteExceptionHandler, remoteMessageModal, routeStopModalService) {

                        var markersHereApi = null;
                        var currentBubble = null;
                        var refreshInterval = null;
                        $scope.routesHereApi = null;
                        $scope.isEditingRoute = false;
                        $scope.isShowingTable = false;
                        $scope.newGeocodesData = [];
                        $scope.markersToAdd = [];
                        $scope.custerMarkersToAdd = [];

                        var localityIconCache = {};

                        $scope.onRegisterRoutesHereApi = function (api) {
                            $scope.routesHereApi = api;
                            $scope.routesHereApi.setTapAction(tapAction());

                            $scope.onRegisterApi({
                                    focusOnStop: $scope.focusOnStop,
                                }
                            );
                            $scope.routesHereApi.setMarkerDragendAction(dragendAction);
                        };

                        $scope.onRegisterMarkersHereApi = function (api) {
                            markersHereApi = api;
                            markersHereApi.setClusterTapAction(tapClusterAction());
                        };

                        $scope.editRoute = function () {
                            $scope.isEditingRoute = !$scope.isEditingRoute;
                            if ($scope.isEditingRoute) {
                                $scope.originalRoutesBackup = angular.copy($scope.routes);
                            }

                            if ($scope.isEditingRoute && currentBubble) {
                                var ui = hereMapsService.getUi();
                                if (ui) {
                                    ui.removeBubble(currentBubble);
                                    currentBubble = null;
                                }
                            }
                            toggleDraggableMarkers();
                        };

                        $scope.saveRoute = function () {
                            $scope.isEditingRoute = !$scope.isEditingRoute;
                            toggleDraggableMarkers();

                            if (!$scope.newGeocodesData) {
                                return messagesModal("dialog.error", ["route.locality.error.no.locality.changed"]);
                            }

                            return messagesModal.cancellable("dialog.warning", ["maps.geolocation.update.confirm"])
                                .then(function () {
                                    return monitoringService.saveGeocodes($scope.newGeocodesData)
                                        .catch(remoteExceptionHandler())
                                        .then(function (message) {
                                            $scope.newGeocodesData = [];
                                            return remoteMessageModal(message);
                                        });
                                }).catch(function(){
                                    if ($scope.routesHereApi) {
                                        $scope.routesHereApi.clearRoutes();
                                    }

                                    $scope.here.routesData.routesHere = [];
                                    $scope.newGeocodesData = [];
                                    if ($scope.originalRoutesBackup) {
                                        $scope.routes = angular.copy($scope.originalRoutesBackup);
                                    }
                                });
                        };

                        function toggleDraggableMarkers() {
                            if ($scope.here.routesData.routesHere) {
                                $scope.here.routesData.routesHere.forEach(function (routeHere) {
                                    var data = routeHere.getData();
                                    if (data && data.markers) {
                                        data.markers.forEach(function (marker) {
                                            marker.draggable = $scope.isEditingRoute;
                                        });
                                    }
                                });
                            }
                        }

                        $scope.tripPanel = function () {
                            $scope.$applyAsync(function () {
                                $scope.isShowingTable = !$scope.isShowingTable;
                                $timeout(function () {
                                    var map = hereMapsService.getMap();
                                    if (map) {
                                        map.getViewPort().resize();
                                    }
                                }, 100);
                            });
                        };

                        function tapAction() {
                            return function (tapContext) {
                                var marker = tapContext.marker;
                                var markerData = marker.getData();

                                if ($scope.isEditingRoute) {
                                    return;
                                }
                                var coordinate = {
                                    lat: markerData.geographicInfo.latitude,
                                    lng: markerData.geographicInfo.longitude
                                };
                                routeStopModalService.openBubble(coordinate, markerData);
                            };
                        }

                        function tapClusterAction() {
                            return function (tapClusterContext) {
                                var markers = tapClusterContext.markers;
                                var target = tapClusterContext.event.target;
                                var clusterPosition = target.getGeometry();

                                var Here = hereMapsService.getHere();
                                var ui = hereMapsService.getUi();

                                var firstMarker = markers[0];
                                var template = firstMarker.getData().popUp.template;

                                var templateParameters = markers.map(function (marker) {
                                    return marker.getData().popUp.templateParameter;
                                });

                                if (currentBubble) {
                                    ui.removeBubble(currentBubble);
                                }

                                var bubbleContent = createHTMLModalWithParameter(template, templateParameters);

                                currentBubble = new Here.ui.InfoBubble(clusterPosition, {
                                    content: bubbleContent
                                });
                                ui.addBubble(currentBubble);
                            };
                        }

                        function toggleAutomaticRefresh() {
                            $scope.here.maps.automaticRefresh.isRefreshing = !$scope.here.maps.automaticRefresh.isRefreshing;
                            if ($scope.onRefreshCallback && $scope.here.maps.automaticRefresh.isRefreshing) {
                                refreshInterval = $interval(function () {
                                    $scope.onRefreshCallback();
                                }, 30000);
                            } else {
                                $interval.cancel(refreshInterval);
                            }
                        }

                        function getConditionalHeight() {
                            var configurations = $scope.configurations;
                            if (!configurations) {
                                return {};
                            }
                            if (!configurations.conditionalHeight) {
                                return {};
                            }
                            return configurations.conditionalHeight;
                        }

                        $scope.here = {
                            maps: {
                                hasFullScreen: true,
                                hasAutomaticRefresh: true,
                                multiplesModes: true,
                                possibleModes: {
                                    hasRouteEdit: true,
                                },
                                possibleButtons: {
                                    hasTripPanel: true,
                                    hasFocusOnMarkers: true
                                },
                                automaticRefresh: {
                                    isRefreshing: false,
                                    action: toggleAutomaticRefresh
                                },
                                conditionalHeight: getConditionalHeight()

                            },
                            markersData: {
                                markersPoints: [],
                                clusterMarkersPoints: [],
                                draggable: false,
                                onRegisterApi: $scope.onRegisterMarkersHereApi
                            },
                            routesData: {
                                routes: [],
                                routesHere: [],
                                onRegisterApi: $scope.onRegisterRoutesHereApi,
                                saveRoute: $scope.saveRoute,
                                editRoute: $scope.editRoute,
                                isEditing: function () {
                                    return $scope.isEditingRoute;
                                },
                                tripPanel: $scope.tripPanel,
                                isShowingTable: function () {
                                    return $scope.isShowingTable;
                                }
                            }
                        };

                        $scope.$watch("routes", setRoutes);

                        function setRoutes() {
                            if (!$scope.routes || $scope.routes.length === 0) {
                                return;
                            }
                            hereMapsLoadingService.start();

                            mapsDirectionsService($scope.routes).then(function (routesDirections) {
                                $scope.here.routesData.routes = routesDirections;

                                $scope.here.routesData.routes.forEach(function (route) {
                                    var routeHere = createRoute(route, true);
                                    if (!routeHere){
                                        return;
                                    }
                                    $scope.here.routesData.routesHere.push(routeHere);
                                });

                            }).then(function () {
                                return preloadIcons($scope.icons);
                            }).then(function () {
                                updateMarkerIcons($scope.here.routesData.routesHere);
                            }).then(function () {
                                $scope.routesHereApi.addRoutes($scope.here.routesData.routesHere);
                                loadAndAppendRouteLegs($scope.here.routesData.routes);
                                if ($scope.markersToAdd.length > 0) {
                                    setMarkers($scope.markersToAdd);
                                    $scope.markersToAdd = [];
                                }
                                if ($scope.clusterMarkersToAdd && $scope.clusterMarkersToAdd.length > 0) {
                                    setClusterMarkers($scope.clusterMarkersToAdd);
                                    $scope.clusterMarkersToAdd = [];
                                }
                            }).finally(function () {
                                hereMapsLoadingService.stop();
                            });
                        }

                        function createRoute(route, includeMarkers) {
                            if (route.selected === undefined) {
                                route.selected = true;
                            }

                            route.presentationNode = getPresentationNode(route, "original");

                            var data = {
                                presentationNode: route.presentationNode,
                                routeTripCode: route.tripCode
                            };

                            if (includeMarkers) {
                                route.markersData = {
                                    markersPoints: route.stopMarkers,
                                    draggable: $scope.isEditingRoute
                                };
                                data.markers = hereMapsMarkersFactory.createMarkers(route.markersData);
                            }
                            return hereMapsRoutesFactory.createRoute(route, data);
                        }

                        function getPresentationNode(route, legType) {
                            return {
                                id: route.presentationNode.id,
                                type: {
                                    messageKey: route.presentationNode.type.messageKey,
                                    name: route.presentationNode.type.name,
                                    legType: legType
                                },
                                version: route.presentationNode.version
                            };
                        }

                        function dragendAction(dragendContext) {
                            var target = dragendContext.marker;
                            var newLatitude = target.getGeometry().lat;
                            var newLongitude = target.getGeometry().lng;

                            var data = target.data;

                            data.geographicInfo.latitude = newLatitude;
                            data.geographicInfo.longitude = newLongitude;

                            var routeToUpdate = findRouteByRouteIdAndLegType(data.routeId, "original");

                            updateLeg(routeToUpdate.startingLeg, data.id, data.geographicInfo);
                            updateLeg(routeToUpdate.endingLeg, data.id, data.geographicInfo);

                            addGeocodeData(target.data.id, newLatitude, newLongitude);
                            updateRoute(data.routeId, routeToUpdate);
                        }

                        function updateLeg(leg, localityId, geographicInfo) {
                            if (!leg) {
                                return;
                            }
                            if (leg.origin.localityId === localityId) {
                                leg.origin.address.geographicInfo = geographicInfo;
                            }
                            if (leg.end.localityId === localityId) {
                                leg.end.address.geographicInfo = geographicInfo;
                            }
                        }

                        function addGeocodeData(localityId, newLatitude, newLongitude) {
                            var existingGeocodeData = $scope.newGeocodesData.find(function (geocodeData) {
                                return geocodeData.localityId === localityId;
                            });

                            if (!existingGeocodeData) {
                                $scope.newGeocodesData.push({
                                    localityId: localityId,
                                    latitude: newLatitude,
                                    longitude: newLongitude
                                });
                            } else {
                                existingGeocodeData.latitude = newLatitude;
                                existingGeocodeData.longitude = newLongitude;
                            }
                        }

                        function updateRoute(routeId, routeToUpdate) {
                            if (!routeToUpdate) {
                                return;
                            }

                            var oldMarkers = getOldMarkers(routeId);
                            $scope.routesHereApi.clearRoutes();
                            $scope.here.routesData.routesHere = [];

                            hereMapsLoadingService.start();
                            mapsDirectionsService([routeToUpdate]).then(function (routesDirections) {
                                var updatedRoute = findRouteById(routesDirections, routeId);
                                if (updatedRoute) {
                                    var newRouteHere = createRoute(updatedRoute, false);
                                    if (oldMarkers) {
                                        newRouteHere.getData().markers = oldMarkers;
                                    }
                                    $scope.here.routesData.routesHere.push(newRouteHere);
                                }
                            }).then(function () {
                                $scope.routesHereApi.addRoutes($scope.here.routesData.routesHere);
                                loadAndAppendRouteLegs($scope.here.routesData.routes);
                            }).finally(function () {
                                hereMapsLoadingService.stop();
                            });
                        }

                        function findRouteByRouteIdAndLegType(routeId, legType) {
                            return $scope.here.routesData.routes.find(function (route) {
                                return route.tripCode === routeId &&
                                    route.presentationNode.type.legType === legType;
                            });
                        }

                        function getOldMarkers(routeId) {
                            var oldRoute = findOldRouteById(routeId);
                            if (oldRoute && oldRoute.getData().markers) {
                                return oldRoute.getData().markers;
                            }
                            return null;
                        }

                        function findOldRouteById(routeId) {
                            return $scope.here.routesData.routesHere.find(function (route) {
                                return route.data.routeTripCode === routeId;
                            });
                        }

                        function findRouteById(routesDirections, routeId) {
                            return routesDirections.find(function (route) {
                                return route.tripCode === routeId;
                            });
                        }

                        function preloadIcons(paths) {
                            if (!paths) {
                                return;
                            }
                            var results = [];
                            paths.forEach(function (path) {
                                var result = $q.defer();
                                var img = new Image();
                                img.onload = function () {
                                    localityIconCache[path] = img;
                                    result.resolve();
                                };
                                img.src = path;
                                results.push(result.promise);
                            });
                            return $q.all(results);
                        }

                        function loadAndAppendRouteLegs(routes) {
                            routes.forEach(function (route) {
                                if (route.startingLeg) {
                                    // Círculos cheios: estão cheios de combustível
                                    // Leg: antes de começar a viagem
                                    renderLeg(route, route.startingLeg, route.color, 0.8, "startingLeg");
                                }
                                if (route.endingLeg) {
                                    // Círculos vazios: deve estar no fim do tanque de combustível
                                    // Leg: retorno a origem
                                    renderLeg(route, route.endingLeg, route.color, 0, "endingLeg");
                                }
                            });
                        }

                        function renderLeg(originalRoute, leg, color, fillOpacity, legType) {
                            var Here = hereMapsService.getHere();
                            // Criar rota "fake" com base na leg de antes de começar a viagem ou de retorno a origem
                            var fakeRoute = getFakeRoute(originalRoute, leg);
                            return mapsDirectionsService([fakeRoute]).then(function (routesDirections) {
                                routesDirections.forEach(function (route) {
                                    var routeHere = hereMapsRoutesFactory.createRoute(fakeRoute,
                                        {
                                            presentationNode: getPresentationNode(route, legType),
                                            markers: []
                                        },
                                        {
                                            strokeColor: getStrokeColor(color, fillOpacity),
                                            lineWidth: 8,
                                            lineDash: [1, 1.5],
                                            lineDashImage: Here.map.SpatialStyle.DashImage.CIRCLE,
                                        }
                                    );
                                    if (routeHere) {
                                        $scope.here.routesData.routesHere.push(routeHere);
                                        $scope.routesHereApi.addRoutes([routeHere]);
                                    }
                                });
                            });
                        }

                        function getStrokeColor(color, fillOpacity) {
                            if (fillOpacity === 0) {
                                return color;
                            }
                            return color + "cc";
                        }

                        function getFakeRoute(route, leg) {
                            var fakeRoute = angular.copy(route);
                            fakeRoute.stops = [];
                            fakeRoute.stops.push(leg.origin, leg.end);
                            return fakeRoute;
                        }

                        function createHTMLModalWithParameter(template, templateParameters) {
                            var modalScope = $scope.$new(true);
                            modalScope.parameters = templateParameters;
                            var compiledElement = $compile(template)(modalScope);
                            return compiledElement[0];
                        }

                        $scope.focusOnStop = function (stop) {

                            var hereMarker = $scope.here.routesData.routesHere
                                .flatMap(function (route) {
                                    return route.getData().markers;
                                })
                                .find(function (marker) {
                                    return marker.getData().id === stop.id;
                                });

                            $scope.routesHereApi.focusOnStopByMarker(hereMarker);
                        };

                        function updateMarkerIcons(routesHere) {
                            routesHere.forEach(function (routeHere) {
                                routeHere.getData().markers.forEach(function (marker) {
                                    var data = marker.getData();
                                    if (!data) {
                                        return;
                                    }
                                    var icon = data.icon;
                                    var stopNumber = data.stopInfo.stopNumber;

                                    var img = localityIconCache[icon];
                                    if (!img) {
                                        return;
                                    }

                                    marker.setIcon(createLocalityIcon(img, stopNumber));
                                });
                            });
                        }

                        function createLocalityIcon(img, stopNumber) {
                            var Here = hereMapsService.getHere();
                            var canvas = document.createElement("canvas");
                            canvas.width = 32;
                            canvas.height = 40;
                            var ctx = canvas.getContext("2d");

                            ctx.drawImage(img, 0, 0);

                            ctx.beginPath();
                            ctx.arc(20, 25, 8, 0, Math.PI * 2);
                            ctx.fillStyle = "#0057D9";
                            ctx.fill();

                            ctx.textBaseline = "middle";
                            ctx.font = "bold 12px Arial";
                            ctx.fillStyle = "#FFFFFF";
                            ctx.textAlign = "center";
                            ctx.fillText(stopNumber, 20, 25);

                            return new Here.map.Icon(canvas.toDataURL(), {
                                anchor: {x: 16, y: 32}
                            });
                        }

                        $scope.$watchCollection("staticRoutes", drawStaticRoutes);

                        $scope.$watch("toggleStaticRoutes", toggleStaticRoutes);

                        function drawStaticRoutes(staticRoutes) {
                            if (!staticRoutes || !$scope.routesHereApi) {
                                return;
                            }
                            $scope.routesHereApi.clearStaticRoutes();
                            (staticRoutes || []).forEach(function (routes) {
                                routes.forEach(function (leg) {
                                    if (!leg || !leg.path) {
                                        return;
                                    }
                                    var legPath = leg.path.map(function (path) {
                                        return {
                                            lat: path.latitude,
                                            lng: path.longitude
                                        };
                                    });
                                    var style = {
                                        strokeColor: leg.color,
                                        lineWidth: 1.5
                                    };
                                    var polyline = hereMapsRoutesFactory
                                        .createPolyline(legPath, leg.color, leg, style);
                                    if (polyline){
                                        $scope.routesHereApi.addStaticRoute(polyline);
                                    }
                                });
                            });
                        }

                        function toggleStaticRoutes(visibility) {
                            if (!$scope.routesHereApi) {
                                return;
                            }
                            $scope.routesHereApi.setVisibilityStaticRoutes(visibility);
                        }

                        $scope.$watch("markersPoints", setMarkersPoints);

                        // escapa no fluxo onde o mapa ainda não carregou para adicionar os markers
                        function setMarkersPoints(markers) {
                            if (!markersHereApi || !hereMapsMarkersFactory || markers.length === 0) {
                                $scope.markersToAdd = markers;
                                return;
                            }
                            setMarkers(markers);
                        }

                        function setMarkers(markers) {
                            markersHereApi.clearMarkers();
                            $scope.here.markersData.markersPoints = markers;
                            var hereMarkers = hereMapsMarkersFactory.createMarkers(
                                $scope.here.markersData);
                            markersHereApi.addMarkers(hereMarkers);
                        }

                        $scope.$watchCollection("clusterMarkersPoints", setClusterMarkersPoints);

                        function setClusterMarkersPoints(clusterMarkers) {
                            if (!markersHereApi || !hereMapsMarkersFactory || clusterMarkers.length === 0) {
                                $scope.clusterMarkersToAdd = clusterMarkers;
                                return;
                            }
                            setClusterMarkers(clusterMarkers);
                        }

                        function setClusterMarkers(custerMarkers) {
                            markersHereApi.clearClusterMarkersLayer();
                            $scope.here.markersData.clusterMarkersPoints = custerMarkers;
                            var clusterMarkers = hereMapsMarkersFactory.createClusterMarkersLayer(
                                $scope.here.markersData
                            );
                            markersHereApi.setClusterMarkersLayer(
                                clusterMarkers.layer, clusterMarkers.provider);
                        }

                        $scope.$on("$destroy", function () {
                            if (refreshInterval) {
                                $interval.cancel(refreshInterval);
                            }
                        });
                    }]
            };
        }
    ]);
});